import Pool from "./pool"
import Equipe from "./equipe";
export default class Tirage {
    options = null;
    nbJoueurs = 0;
    pools = [];
    eliminatoire=[];
    constructor (options) {
        this.options = options;
        this.nbJoueurs = options.nbJoueurs;
    }
    searchIndexPoolASup (pools, indexPool) {
        if (pools[indexPool].joueurs.length<=this.options.nbMinJoueursParPool)
            return this.searchIndexPoolASup(pools, indexPool-1);
        else
            return indexPool;
    }
    initPools(nbPoolsParam) {

        var nbPools = this.nbJoueurs / this.options.nbJoueursParPool;
        
        if (typeof(nbPoolsParam)!="undefined") {
            if (nbPoolsParam>nbPools) {
                nbPools = nbPoolsParam
            }
        }
        
        
        var listNumeroJoueurs=[];
        for (var indexJoueur=0;indexJoueur<this.nbJoueurs;indexJoueur++) {
            listNumeroJoueurs.push(indexJoueur);
        }
       
        var indexPool;
        var bool = false;
        for (indexPool=0;indexPool<nbPools;indexPool++) {
            this.pools[indexPool] = new Pool (this.options, indexPool);
            this.pools[indexPool].initJoueurs(listNumeroJoueurs);
        }
      
        indexPool--;
        bool = (this.pools[indexPool].joueurs.length < this.options.nbMinJoueursParPool);
        // Là je remet les joueurs pour qu'il y a un minimum de 3 dans chaque POOL;
        while (bool) {
            if (this.pools[indexPool].joueurs.length < this.options.nbMinJoueursParPool) {
                var indexPoolSearch = this.searchIndexPoolASup(this.pools, indexPool-1);
                var indexJoueurASup =  this.pools[indexPoolSearch].joueurs.length-1;
                var numeroJoueur = this.pools[indexPoolSearch].joueurs[indexJoueurASup];
                this.pools[indexPool].joueurs.push(numeroJoueur);
                this.pools[indexPoolSearch].joueurs.splice(indexJoueurASup, 1);
            }
            else {
                indexPool--;
                if (indexPool<0)
                    bool = false;
            }
        }
    }
    init() {
      
        this.pools.forEach(pool=>{
            pool.init();
        })
    }
    getJson() {
        var poolJson = [];
        this.pools.forEach(pool=>{
            poolJson.push( pool.getJson())
        })
        return poolJson;
    }
    isInPoule(numero, numeroFind, poule) {
        var findPoule = false;
        var find2Numeros = false;
        var indexPoule=0;
        while (!findPoule) {
            poule[indexPoule].forEach(itemPoule=>{
                findPoule = itemPoule.numero == numero;
            })
            if (findPoule) {
                poule[indexPoule].forEach(itemPoule=>{
                    find2Numeros = itemPoule.numero == numeroFind;
                })  
            }
            indexPoule++;
            if (indexPoule>=poule.length)
                findPoule = true;
        }
        
        return find2Numeros;
    }
    findNumero (numero, decrementClassement, poule) {
        var tempoDecrementClassement = decrementClassement.slice();
        var indexFind = tempoDecrementClassement.length-1;
        
        var numeroFind = tempoDecrementClassement[indexFind].numero;
        if (!this.isInPoule(numero, numeroFind, poule))
            return {
                numero: numeroFind,
                index: indexFind
            }
        else {
            tempoDecrementClassement.splice(indexFind, 1);
            return this.findNumero(numero, tempoDecrementClassement, poule);
        }
    }
    eliminatoireClassique(poule) {
      
        var classementGeneral = [];
        poule.forEach(itemPoule=>{
            itemPoule.forEach(equipe=>{
                if (equipe.qualifie)
                    classementGeneral.push(equipe);
            })
        })
        classementGeneral.sort((j1,j2)=>{
            return j2.win - j1.win || j2.goalAverage - j1.goalAverage;
        })
      
        var nbEquipes = classementGeneral.length / 2;
        var decrementClassement = classementGeneral.slice();
        var jsonEquipe = {
            equipes: []
        };
        var indiceEquipeA = 0;
        var indiceEquipeB = nbEquipes-1;
        var alterne = true;
        classementGeneral.forEach((equipeClassement, indexEquipeClassement)=>{
            if (nbEquipes>0) {
                var equipe = new Equipe();
                equipe.dataJoueurs.joueurs.J1 = equipeClassement.numero;

                var jsonFind = this.findNumero(equipeClassement.numero, decrementClassement, poule);
                decrementClassement.splice(jsonFind.index, 1);
                equipe.dataJoueurs.contre.J1 = jsonFind.numero;
                if (alterne) {
                    jsonEquipe.equipes[indiceEquipeA] = equipe.getJson();
                    indiceEquipeA++;
                }
                else {
                    jsonEquipe.equipes[indiceEquipeB] = equipe.getJson();
                    indiceEquipeB--;
                }
                alterne = !alterne;
                nbEquipes--;
            }
        })
        return jsonEquipe;
    }
}